module.exports = __webpack_public_path__ + "static/media/Montserrat-Thin.143850af.eot";